import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_property_grid = _resolveComponent("g-property-grid");
    return (_openBlock(), _createBlock(_component_g_property_grid, {
        schema: _ctx._schema,
        data: _ctx._data
    }, null, 8, ["schema", "data"]));
}
